<template>
  <div class="header">
    <ul class="header-button-left">
      <li v-if="iStep != 0" @click="iStep = 0">Cancel</li>
    </ul>
    <ul class="header-button-right">
      <li v-if="iStep == 1" @click="iStep = 2">Next</li>
      <li v-if="iStep == 2" @click="publish()">Add</li>
    </ul>
    <img src="./assets/logo.png" class="logo" />
  </div>

  <!-- <h4>안녕 {{ $store.state.name }} 나이 {{ $store.state.age }}</h4>
  <button @click="$store.commit('이름변경', 'Park')">이름변경</button> -->
  <!-- <button @click="$store.commit('증가', 10)">증가</button> -->
  <!-- <button @click="증가(10)">증가</button> -->

  <!-- <p>{{ $store.state.more }}</p>
  <button @click="$store.dispatch('getDate')">더보기버튼</button> -->

  <Container @saveContent="content = $event" :PostData="PostData" :iStep="iStep" :url="url" />

  <!-- <button @click="more()">더보기</button> -->

  <!-- <p>{{ name }} {{ age }} {{ 내이름 }}</p>
  <button @click="카운터++">버튼</button> -->

  <div class="footer">
    <ul class="footer-button-plus">
      <input @change="upload" accept="image/*" type="file" id="file" class="inputfile" />
      <label for="file" class="input-plus">+</label>
    </ul>
  </div>

  <!-- <div v-if="iStep == 0">내용0</div>
  <div v-if="iStep == 1">내용1</div>  
  <div v-if="iStep == 2">내용2</div>    
  <button @click="iStep = 0">버튼0</button>
  <button @click="iStep = 1">버튼1</button>
  <button @click="iStep = 2">버튼2</button>    

  <div style="margin-top : 500px;"></div> -->

</template>

<script>

import AppContainer from './components/AppContainer.vue';
import LocalData from './assets/postdata.js';
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      PostData: LocalData,
      moreIndex: 0,
      iStep: 0,
      url: '',
      content: '',
      filter: '',
      카운터: 0,
    }
  },
  mounted() {
    this.emitter.on('filter', (a) => {
      console.log(a);
      this.filter = a;
    }),
    this.emitter.on('likeClick', (i) => {
        if(this.PostData[i].liked == true){
            this.PostData[i].liked = false;
            this.PostData[i].likes--;
            // console.log('like 감소');
        } else {
            this.PostData[i].liked = true;
            this.PostData[i].likes++;
            // console.log('like 증가');
        }
    })
  },
  components: {
    Container: AppContainer,
  },
  computed : {
    now2() {
      return new Date();
    },
    ...mapState(['name','age']),
    ...mapState({ 내이름 :'name',}),
  },
  methods: {
    ...mapMutations(['setMore','증가']),
    now() {
      return new Date();
    },
    more() {
      // axios.get('https://codingapple1.github.io/vue/more' + this.moreIndex + '.json')
      axios.get(`https://codingapple1.github.io/vue/more${this.moreIndex}.json`)
        .then((result) => { //애로우 펑션으로 사용하면 this를 재정의 하지 않고 밖에 있는걸 잘씀
          //요청성공시 실행할 코드 ~~
          // console.log(result.data);
          this.PostData.push(result.data);
          this.moreIndex++;
        })
        .catch((err) => {
          console.log(err.message);
        })
    },
    upload(e) {
      var 파일 = e.target.files;
      // console.log(파일[0]);
      let url = URL.createObjectURL(파일[0]);
      // console.log(url);
      this.url = url;
      this.iStep = 1
    },
    publish() {
      var 내게시물 = {
        name: "Ji Youngil",
        userImage: "https://picsum.photos/100?random=3",
        postImage: this.url,
        likes: 0,
        date: this.getFormattedDate(),
        liked: false,
        content: this.content,
        filter: this.filter
      }
      this.PostData.unshift(내게시물);
      this.iStep = 0
    },
    getFormattedDate(date = new Date()) {
      const targetDate = date; // 인자로 받은 날짜를 사용하거나, 없으면 오늘 날짜 사용

      const options = { month: 'long', day: 'numeric' };
      const formatter = new Intl.DateTimeFormat('en-US', options);

      return formatter.format(targetDate);
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

ul {
  padding: 5px;
  list-style-type: none;
}

.logo {
  width: 22px;
  margin: auto;
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 13px;
}

.header {
  width: 100%;
  height: 40px;
  background-color: white;
  padding-bottom: 8px;
  position: sticky;
  top: 0;
}

.header-button-left {
  color: skyblue;
  float: left;
  width: 50px;
  padding-left: 20px;
  cursor: pointer;
  margin-top: 10px;
}

.header-button-right {
  color: skyblue;
  float: right;
  width: 50px;
  cursor: pointer;
  margin-top: 10px;
}

.footer {
  width: 100%;
  position: sticky;
  bottom: 0;
  padding-bottom: 10px;
  background-color: white;
}

.footer-button-plus {
  width: 80px;
  margin: auto;
  text-align: center;
  cursor: pointer;
  font-size: 24px;
  padding-top: 12px;
}

.sample-box {
  width: 100%;
  height: 600px;
  background-color: bisque;
}

.inputfile {
  display: none;
}

.input-plus {
  cursor: pointer;
}

#app {
  box-sizing: border-box;
  font-family: "consolas";
  margin-top: 60px;
  width: 100%;
  max-width: 460px;
  margin: auto;
  position: relative;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
</style>
